import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import App from "@/App";
import { registerSW } from "@/lib/registerSW";
import { hydrateStorage } from "@/lib/durableStorage";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

// Hydrate native storage into synchronous mirror BEFORE first React render so
// AuthContext.useState(loadCached) sees the persisted token/user on cold boot.
hydrateStorage().finally(() => {
  const root = ReactDOM.createRoot(document.getElementById("root"));
  root.render(
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>,
  );
  registerSW();
});
